'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('managerialpot', {
      url: '/managerialpot',
      template: '<managerialpot></managerialpot>'
    });
}
